import { Data_getInstance34t53wgrn3an7 as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CreateSecretMutation_VariablesAdapter_instance2aq2ogjf8avhz as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.z6f_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.z6f_1) + ')';
      }
      hashCode() {
        return this.z6f_1 == null ? 0 : this.z6f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.z6f_1, other.z6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.a6g_1 = secretId;
        this.b6g_1 = description;
        this.c6g_1 = createdTimestamp;
        this.d6g_1 = lastUsedTimestamp;
        this.e6g_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.a6g_1.toString() + ', description=' + this.b6g_1 + ', createdTimestamp=' + this.c6g_1.toString() + ', lastUsedTimestamp=' + toString(this.d6g_1) + ', secretToken=' + this.e6g_1 + ')';
      }
      hashCode() {
        var result = this.a6g_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.b6g_1) | 0;
        result = imul(result, 31) + this.c6g_1.hashCode() | 0;
        result = imul(result, 31) + (this.d6g_1 == null ? 0 : this.d6g_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.a6g_1.equals(other.a6g_1))
          return false;
        if (!(this.b6g_1 === other.b6g_1))
          return false;
        if (!this.c6g_1.equals(other.c6g_1))
          return false;
        if (!equals(this.d6g_1, other.d6g_1))
          return false;
        if (!(this.e6g_1 === other.e6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.f6g_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.g6g_1 = 'createSecret';
      }
      h6g() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.i6g_1 = input;
      }
      j6g() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.j6g();
      }
      x48() {
        return Companion_instance.h6g();
      }
      k6g() {
        return 'createSecret';
      }
      operationName() {
        return this.k6g();
      }
      r47(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.l6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      q47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.i6g_1.toString() + ')';
      }
      hashCode() {
        return this.i6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.i6g_1.equals(other.i6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
